import React,{ useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FormControlLabel,RadioGroup,Radio,FormControl,FormLabel } from '@material-ui/core/';
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import MenuBtn from './MenuBtn';
import MenuCircleBtnBacklite from './MenuCircleBtnBacklite';
import MenuCircleBtn from './MenuCircleBtn';
import MenuCircleBtnOpenClose from './MenuCircleBtnOpenClose';
import MenuCircleBtnVideo from './MenuCircleBtnVideo';


// import RadioBtns from './RadioBtns';
const ProductViewHeader = {
   borderBottom: "1px solid #c7c7c7",
   minHeight: "42px"
}
const openclose = {
   width: "36px",
   height: "36px !important"
}
const Btn = {
   borderRadius: "0px",
   background: 'transparent',
   border: 'none',
   boxShadow: 'none',
   marginLeft: '10px',
   color: '#000',
   textTransform: 'capitalize',
   marginRight: "25px"
}
const BtnIcon = {
   borderRadius: "0px",
   background: 'transparent',
   width: '36px',
   height: '36px'
}
const MenuFeatures = (props) => {

   // const [backlit, setBacklite] = useState("./img/Backlite_Off.svg");
   // const [opneClose, setOpenClose] = useState("./img/open.png");

   return (
      <div className="Accordians">
         <Accordion style={{ borderRadius: "0px",borderBottom: '1px solid #CCCCCC' }} onChange={props.onChanged} expanded={props.expanded}>
            <AccordionSummary tabIndex="-1" id="feature"
               expandIcon={<ExpandMoreIcon />} style={ProductViewHeader}>
               <Typography className="accordion-headers AccordiansHeader" style={{ fontWeight: "700" }}>{props.name}</Typography>
            </AccordionSummary>
            <AccordionDetails className="selectRadioBtn">
               <FormLabel component="legend">Capacitive touch function row :</FormLabel>
               <RadioGroup value={props.onRadioDefault} name="radio-buttons-group">
                  <FormControlLabel value="keyFunctionMode" control={<Radio />} label="Function Mode" tabIndex="1" id='functionMode' onKeyPress={props.keyFunction} onClick={props.keyFunction} />
                  <FormControlLabel value="keyMediaMode" control={<Radio />} label="Media Mode" tabIndex="1" id='mediaMode' className="active" onKeyPress={props.keyMedia} onClick={props.keyMedia} />
                  <FormControlLabel value="keyTouchMode" control={<Radio />} label="OFF" tabIndex="1" id='touchFun' onKeyPress={props.keyTouch} onClick={props.keyTouch} />
               </RadioGroup>
            </AccordionDetails>
            {/* <RadioGroup className="Radio" name="gender1" value={props.value} >
                  <FormControlLabel id="laptop2in1" style={{ minwidth: "200px" }} aria-labelledby="" tabIndex="1" onKeyPress={props.onclickedtwo} onClick={props.onclickedtwo} value="2 in 1" control={<Radio id='twoinoneRadio' color="primary" />} label="Tower" />
                  <FormControlLabel id="laptop" style={{ minwidth: "200px" }} tabIndex="1" onKeyPress={props.onclicked} onClick={props.onclicked} value="laptop" control={<Radio id="laptopRadio" color="primary" />} label="Small Form Factor" />
                  <FormControlLabel id="laptop1" style={{ minwidth: "200px" }} tabIndex="1" onKeyPress={props.onclickedone} onClick={props.onclickedone} value="laptop1" control={<Radio id="laptopRadio1" color="primary" />} label="Micro Form Factor" />
               </RadioGroup> */}

            <AccordionDetails tabIndex="1" id="backlitBtn" onKeyPress={props.onOffBackliteClicked} onClick={props.onOffBackliteClicked}>
               <MenuCircleBtnBacklite changeBacklitImg={props.tobeChanged} submenu="Backlit Keyboard" />
            </AccordionDetails>
            <AccordionDetails tabIndex="1" id="openCloseBtn" onKeyPress={props.openClosedClicked} onClick={props.openClosedClicked}>
               <MenuCircleBtnOpenClose changeOpenCloseImg={props.tobechange} className="openclose" submenu="Open/Close Lid" />
            </AccordionDetails>
            <AccordionDetails tabIndex="1" id="playPauseVBtn" aria-label="Play Video" onKeyPress={props.onPlayPausevideoClicked} onClick={props.onPlayPausevideoClicked} >
               <MenuCircleBtnVideo changePlaypauseImg={props.playPauseVideo} submenu="Play Video" />
            </AccordionDetails>

         </Accordion>
      </div>
   );
}

export default MenuFeatures;